export const STATUS_DRAFT = 'draft';
export const STATUS_SCHEDULED = 'scheduled';
export const STATUS_SENT = 'sent';

export const STATUSES = [STATUS_DRAFT, STATUS_SENT, STATUS_SCHEDULED];
